<div class="row">
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e nome'"
		[valueInput]="(legaleIncaricato.legale.cognome ? legaleIncaricato.legale.cognome : '')+(legaleIncaricato.legale.nome ? (' ' + legaleIncaricato.legale.nome) : '')"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo persona'"
		[valueInput]="legaleIncaricato.legale?.tipoPersona.label"></div>
	<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" 
		[typeLabel]="'checklist'" [labelInput]="'Ambito di competenza'"
		[checkListValue]="legaleIncaricato.legale?.ambitiCompetenza"></div>
</div>
<div class="row">
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Codice fiscale'"
		[valueInput]="legaleIncaricato.legale?.codiceFiscale"></div>
	<div *ngIf="isPrd" labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'boolean'"
		[labelInput]="'In convenzione'"
		[valueInput]="legaleIncaricato.legale?.convenzione"></div>
	<div *ngIf="isPrd" labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tariffa'"
		[valueInput]="legaleIncaricato.legale?.tariffa"></div>
</div>

<div class="row">
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Ragione sociale'"
		[valueInput]="legaleIncaricato.legale?.ragioneSociale"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Partita Iva'"
		[valueInput]="legaleIncaricato.legale?.partitaIva"></div>
	<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'CF Rappresentante legale'"
		[valueInput]="legaleIncaricato.legale?.codiceFiscaleRappresentanteLegale"></div>
	<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo societ&agrave;'"
		[valueInput]="legaleIncaricato.legale.tipoSocieta ? legaleIncaricato.legale.tipoSocieta.label : ''"></div>
</div>

<div class="row container_fieldset">
	<div class="col-xs-12 col-sm-12">
		<fieldset class="form-group">
			<legend>Nascita <span class="sr-only">legale</span></legend>
			<div labelTextInput class="col-xs-12 col-sm-2 bloccodati" [typeLabel]="'date'"
				[labelInput]="'Data'"
				[valueInput]="legaleIncaricato.legale?.dataNascita"></div>
			<div labelTextInput class="col-xs-12 col-sm-5 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Comune'"
				[valueInput]="legaleIncaricato.legale.comuneNascita?.label"></div>
			<div labelTextInput class="col-xs-12 col-sm-5 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Provincia'"
				[valueInput]="legaleIncaricato.legale.provinciaNascita?.label"></div>
		</fieldset>
	</div>
</div>

<div class="row container_fieldset">
	<div class="col-xs-12 col-sm-12">
		<fieldset class="form-group">
			<legend>Residenza <span class="sr-only">legale</span></legend>
			<div labelTextInput class="col-sm-8 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Indirizzo'"
				[valueInput]="legaleIncaricato.legale?.indirizzo"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Cap'" [valueInput]="legaleIncaricato.legale?.cap"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Comune'"
				[valueInput]="legaleIncaricato.legale?.comuneResidenza?.label"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Provincia'"
				[valueInput]="legaleIncaricato.legale.provinciaResidenza?.label"></div>
		</fieldset>
	</div>
</div>

<div class="row container_fieldset">
	<div class="col-xs-12 col-sm-12">
		<fieldset class="form-group">
			<legend>Contatti <span class="sr-only">legale</span></legend>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Telefono'"
				[valueInput]="legaleIncaricato.legale.telefono"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Cellulare'"
				[valueInput]="legaleIncaricato.legale.cellulare"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Fax'" [valueInput]="legaleIncaricato.legale.fax"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Email'" [valueInput]="legaleIncaricato.legale.email"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Pec'" [valueInput]="legaleIncaricato.legale.pec"></div>
		</fieldset>
	</div>
</div>
			<div class="row">
				<div class="col-sm-12 bloccodati">
					<p>
						<label class="col-sm-12">Note</label>
						<span class="longtext">{{ legaleIncaricato.legale.note }}</span>
					</p>
				</div>
<!-- 				<div labelTextInput class="col-sm-12 bloccodati" -->
<!-- 					[typeLabel]="'text'" [labelInput]="'Note'" -->
<!-- 					[valueInput]="legaleIncaricato.legale.note"></div> -->
			</div>
